import { MyModulesNoResults } from '@pickleballinc/ui/components/global/myModules/MyModulesNoResults';

import { PlayerTournamentCard } from '@/modules/players/v2/tabs/components/PlayerTournamentCard';
import { getNoResultsConfig } from '@/modules/players/v2/tabs/helpers';
import { PlayerData } from '@/types/players.types';
import { PlayerTournamentsData } from '@/types/playerTournaments.types';

interface UpcomingTournametsProps {
  data?: PlayerTournamentsData[];
  player?: PlayerData;
  isUserAlsoPlayer?: boolean;
  createTournamentUrl: string;
}

export function ManageTournaments({
  data,
  player,
  isUserAlsoPlayer,
  createTournamentUrl,
}: UpcomingTournametsProps) {
  const noResultsConfig = getNoResultsConfig({
    moduleType: 'tournament',
    player,
    isManage: true,
    isRegistered: false,
    isUserAlsoPlayer,
    createUrl: createTournamentUrl,
  });

  return data && data.length > 0 ? (
    <div className='mb-6 mt-0 sm:mt-4 grid grid-cols-1 min-[500px]:grid-cols-2 gap-4 py-4 md:grid-cols-3 md:gap-6 lg:grid-cols-4'>
      {data.map((tourney) => {
        return (
          <PlayerTournamentCard
            key={`tournament-manage-card-${tourney.tournamentUuid}`}
            tourney={tourney}
            isManagingCard
          />
        );
      })}
    </div>
  ) : (
    <div className='mx-auto max-w-[442px] py-6'>
      <MyModulesNoResults {...noResultsConfig} />
    </div>
  );
}
